import { Component } from '@angular/core';
import { IonicPage, ViewController, NavParams } from 'ionic-angular';

import{Condominium}from '../../models/models';

@IonicPage()
@Component({
	selector: 'page-settlement-modal',
	templateUrl: 'settlement-modal.html',
})
export class SettlementModalPage {
	//public url:string;
	condominium:Condominium;

	constructor(
		public viewCtrl: ViewController,
		public navParams: NavParams
	){
		//this.url=navParams.get('url');
		this.condominium=<Condominium>navParams.get('condominium');
		console.log('Condominio per il regolamento: '+this.condominium);
	}

	onError(error){
		console.error('Errore visualizzando il pdf del regolamento '+this.condominium,error);
	}
	dismiss() {
		this.viewCtrl.dismiss();
	}
}



// WEBPACK FOOTER //
// ./src/pages/settlement-modal/settlement-modal.ts